import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import InputGroup from '../../common/InputGroup';

const ExpenseItemInput = ({
  labelText,
  initialValue,
  index,
  errors,
  fieldName,
  updateData,
  className
}) => {
    const {t} = useTranslation();

    const [value, setValue] = useState(initialValue);

    const onChange = e => {
        setValue(e.target.value);
    }

    const onBlur = () => {
        updateData(index, fieldName, value);
    }

    useEffect(() => {
        setValue(initialValue)
    }, [initialValue]);

    const hasError = () => {
        return errors && errors[fieldName]?.touched && !errors[fieldName]?.valid;
    }

    return (
        <InputGroup
            labelText={labelText}
            errorText={hasError() ? errors[fieldName].error : ''}
            classes={className}
            withBorder
        >
            <input
                type="text"
                className={`form-control ${hasError() ? 'error' : ''}`}
                value={value || ''}
                onChange={onChange}
                onBlur={onBlur}
            />
        </InputGroup>
    )
};

export default ExpenseItemInput;